<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div class="md-layout-item md-size-65 md-small-size-95 mx-auto">
            <h2 class="black text-center text-primary">{{$t('Conference locations')}}</h2>

            <template v-if="items.length">
              <div
                v-for="item in items"
                :key="item.id"
                style="margin:0px 0px;"
                class="md-layout-item md-size-100"
              >
                <div class="item" @click="showDetails(item)">
                  <span class="text-gray regular" style="font-size:18px">{{item.name}}</span>
                </div>
              </div>
            </template>

            <no-data v-else class="md-layout-item md-size-100" />
          </div>
        </div>
      </div>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedItem }">
      <modal v-if="selectedItem" @close="selectedItem = null" id="building-modal">
        <template slot="header">
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedItem = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <building-details :id="selectedItem.id" />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions, mapMutations } from "vuex";
import axios from "@/util/axios";
import { Modal } from "@/components";
import PageHeader from "./layout/PageHeader";
import BuildingDetails from "./BuildingDetailsPage.vue";
import NoData from "@/pages/authenticated/NoData";

export default {
  components: { Modal, PageHeader, NoData, BuildingDetails },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  },
  data() {
    return {
      loaded: false,
      items: [],
      selectedItem: null,
      image: require("@/assets/img/conference/landing-bg-fe26.jpg") // header img
    };
  },
  methods: {
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        this.items = (
          await axios.get("public/conferences/conference/buildings", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      } finally {
        loader.hide();
        this.loaded = true;
      }
    },
    async showDetails(item) {
      // console.log(item);

      this.selectedItem = item;
      // await axios.post("public/myprofile/notifications/read/add", {
      //   id: item.id
      // });

      // this.selectedItem = item;
      // item.isRead = true;
      // this.setCount(this.count);
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async language() {
      this.loaded = false;
      this.model = { items: [] };
      await this.loadData();
    }
  }
};
</script>


<style lang="scss" scoped>
.item {
  cursor: pointer;
  margin: 0px 0px;
  padding: 7px 0px;
  &:hover {
    box-shadow: 0px 0px 30px #0000000d;
    border-radius: 15px;
    opacity: 1;
  }
}
</style>
